import { styled } from "@mui/material";
import { colorPickerName } from "../../../../../../../classes.js";
const TextAligner = styled("div", {
  name: colorPickerName,
  slot: "TextAligner"
})(() => ({
  alignItems: "center",
  display: "flex",
  height: "inherit"
}));
export {
  TextAligner
};
//# sourceMappingURL=TextAligner.js.map
